import { j as i } from "./jsx-runtime-944c88e2.js";
import { Center as D, Box as p, Flex as a, Text as s, Image as S, Spacer as k, Tag as u, Stack as T, Circle as W, Button as z } from "@chakra-ui/react";
import { u as K, T as x, af as L } from "./eMyAsurionProvider-729b3d93.js";
import "@tanstack/react-query";
import "react";
import "./useAccount-78ba59e2.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/icons";
import "./features-b5f79a23.js";
import "./providers-0da5f61c.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-7d097fe4.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "mixpanel-browser";
import "@emotion/styled";
const f = (d) => {
  const t = {
    "light blue": "#ADD8E6",
    "jet black": "#0A0A0A",
    gold: "#FAD8BD",
    "beige/cream": "#F5F5DC",
    glow: "#FCE29A",
    "sierra blue": "#9BB5CE",
    midnight: "#171E27",
    green: "#364935",
    "light purple": "#D1CDDA",
    coral: "#EE7762",
    "light green": "#AEE1CD",
    silver: "#E7E7E7"
  }, l = d.toLowerCase();
  return l in t ? t[l] : "#FCE29A";
}, pi = ({
  children: d,
  deviceContent: t,
  texts: l,
  textColor: y,
  textCapacity: b,
  nextButtonProps: c,
  selectedColor: w,
  selectedStorage: C,
  onStorageClick: h,
  onColorClick: g,
  enableButton: m,
  ...F
}) => {
  const { data: A } = K(), { theme: $ } = A, { colors: e } = $, n = "DeviceSelection", E = (r) => r == "1" ? `${r}TB` : `${r}GB`;
  return /* @__PURE__ */ i.jsx(D, { children: /* @__PURE__ */ i.jsxs(p, { ...F, w: { base: "full", lg: "60%" }, m: "auto", children: [
    /* @__PURE__ */ i.jsx(p, { children: t.map((r, o) => /* @__PURE__ */ i.jsxs(
      a,
      {
        direction: { base: "column", lg: "row" },
        id: "myasurion",
        p: 0,
        children: [
          (r == null ? void 0 : r.assetFamily) && /* @__PURE__ */ i.jsx(
            s,
            {
              id: "myasurion-profile-avatar",
              w: "full",
              h: "auto",
              p: "16px 0px",
              fontSize: "32px",
              children: r == null ? void 0 : r.assetFamily
            }
          ),
          /* @__PURE__ */ i.jsx(p, { children: /* @__PURE__ */ i.jsx(S, { margin: "auto", src: r.img, alt: "no-image", w: "130px" }) })
        ]
      },
      `device-content-${o}`
    )) }),
    /* @__PURE__ */ i.jsxs(p, { w: "full", h: "auto", p: "24px 0px", children: [
      /* @__PURE__ */ i.jsxs(a, { children: [
        /* @__PURE__ */ i.jsx(s, { fontWeight: "700", children: /* @__PURE__ */ i.jsx(
          x,
          {
            text: b,
            translationKey: `${n}/CapacityText`
          }
        ) }),
        /* @__PURE__ */ i.jsx(k, {})
      ] }),
      t[0].assetCapacity.map((r, o) => /* @__PURE__ */ i.jsx(
        u,
        {
          p: "16px 16px",
          m: "8px 5px",
          border: C == r ? `2px solid ${e == null ? void 0 : e.accent}` : "1px solid #A5AAAF",
          fontWeight: "700",
          background: "#FFF",
          onClick: () => {
            h && h(r);
          },
          children: /* @__PURE__ */ i.jsx(
            x,
            {
              text: E(r),
              translationKey: `${n}/${r}`
            }
          )
        },
        `asset-capacity-${o}`
      ))
    ] }),
    /* @__PURE__ */ i.jsxs(p, { id: "myasurion-profile-avatar", w: "full", h: "auto", children: [
      /* @__PURE__ */ i.jsx(a, { children: /* @__PURE__ */ i.jsx(s, { fontWeight: "700", children: /* @__PURE__ */ i.jsx(x, { text: y, translationKey: `${n}/ColorText` }) }) }),
      t[0].color.map((r, o) => /* @__PURE__ */ i.jsx(
        u,
        {
          width: "100px",
          height: "100px",
          padding: "9px",
          margin: "7px",
          border: w == r ? `2px solid ${e == null ? void 0 : e.accent}` : "1px solid #A5AAAF",
          fontWeight: 700,
          background: "#FFFFFF",
          onClick: () => {
            g && g(r);
          },
          children: /* @__PURE__ */ i.jsxs(T, { margin: "auto", minWidth: "max-content", alignItems: "center", children: [
            /* @__PURE__ */ i.jsx(
              W,
              {
                borderWidth: r.toLowerCase() == "white" ? "1px" : "0px",
                borderRadius: "50%",
                borderColor: "gray.500",
                backgroundColor: r.toLowerCase() == "gold" || r.toLowerCase() == "silver" ? f(r) : L(r) || f(r),
                size: "28px"
              }
            ),
            /* @__PURE__ */ i.jsx(s, { fontWeight: "700", children: /* @__PURE__ */ i.jsx(
              x,
              {
                text: r,
                translationKey: `${n}/${r}`
              }
            ) })
          ] })
        },
        `color=${o}`
      ))
    ] }),
    /* @__PURE__ */ i.jsx(
      p,
      {
        p: "24px 16px",
        bg: "white",
        position: "fixed",
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: "3",
        style: { boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)" },
        w: "full",
        children: t.map((r, o) => /* @__PURE__ */ i.jsxs(
          a,
          {
            justifyItems: "center",
            w: { base: "full", lg: "50%" },
            m: "auto",
            children: [
              /* @__PURE__ */ i.jsxs(a, { direction: "column", children: [
                /* @__PURE__ */ i.jsx(s, { fontSize: "md", lineHeight: "tall", children: l }),
                /* @__PURE__ */ i.jsxs(s, { fontSize: "md", lineHeight: "tall", children: [
                  /* @__PURE__ */ i.jsx(
                    x,
                    {
                      text: "from ",
                      translationKey: `${n}/TextScript2`
                    }
                  ),
                  /* @__PURE__ */ i.jsx(s, { lineHeight: "tall", fontSize: "2xl", as: "b", children: r.srf })
                ] })
              ] }),
              /* @__PURE__ */ i.jsx(
                z,
                {
                  onClick: () => {
                    var j;
                    return (j = c.onClick) == null ? void 0 : j.call(c);
                  },
                  ml: "auto",
                  isDisabled: !m,
                  marginY: "auto",
                  colorScheme: "primary",
                  p: "12px 20px",
                  style: {
                    cursor: m ? "" : "not-allowed",
                    background: m ? e.primary : "gray",
                    color: m ? "white" : "lightGray"
                  },
                  children: /* @__PURE__ */ i.jsx(
                    x,
                    {
                      text: c.label,
                      translationKey: `${n}/NextButtonLbl`
                    }
                  )
                }
              )
            ]
          },
          `dev-content-${o}`
        ))
      }
    )
  ] }) });
};
export {
  pi as DeviceSpecification
};
